import { Builder } from '@builder.io/react';

import { Schedule } from './index';

Builder.registerComponent(Schedule, {
  name: 'Summit Schedule',
  inputs: [
    {
      name: 'preliminarySchedule',
      type: 'list',
      defaultValue: [
        {
          date: 'November 1st',
          day: 'Wednesday',
          items: [
            { content: 'Arrival and Registration' },
            { content: 'Welcome reception & executive dinner' }
          ]
        },
        {
          date: 'November 2nd',
          day: 'Thursday',
          items: [
            { content: 'Morning Sessions' },
            { content: 'Lunch and Networking' },
            { content: 'Afternoon Roundtable discussions' },
            { content: 'Curated activities around Park City' },
            { content: 'Lodge Dinner & Nightcap' }
          ]
        },
        {
          date: 'November 3rd',
          day: 'Friday',
          items: [
            { content: 'Morning session and event summary' },
            { content: 'Lunch and networking' },
            { content: 'Departure' }
          ]
        }
      ],
      subFields: [
        {
          name: 'date',
          type: 'string'
        },
        {
          name: 'day',
          type: 'string'
        },
        {
          name: 'items',
          type: 'list',
          subFields: [
            {
              name: 'content',
              type: 'string'
            }
          ]
        }
      ]
    }
  ]
});
